<template>
    <div class="designeroption" data-designer-component-id="door_core">
        <div class="stylesoption">
            <div class="coreoption">
                <table>
                    <tbody>
                    <tr>
                        <td>&nbsp;</td>
                        <td>Solid Core</td>
                        <td>Thermal Core</td>
                    </tr>
                    <tr>
                        <td>44mm</td>
                        <td><input type="radio" v-model="localTarget" :value="['44mm', 'solid']"></td>
                        <td><input type="radio" v-model="localTarget" :value="['44mm', 'thermal']"></td>
                    </tr>
                    <tr>
                        <td>54mm</td>
                        <td><input type="radio" v-model="localTarget" :value="['54mm', 'solid']"></td>
                        <td><input type="radio" v-model="localTarget" :value="['54mm', 'thermal']"></td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="clearfix"></div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    export default {
        props: {
            target: {
                required: true,
            }
        }
    }
</script>
